/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Badge,
  Popconfirm,
  Avatar,
  Layout,
  Table,
  Input,
} from "antd";
import { ALL_BLOG, DELETE_BLOG, IMAGE_BASE_URL } from "../../constants/api";
import dayjs from "dayjs";

function BlogTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const formattedData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          Name: row.title,
          Date: dayjs(row.publish_date).format("MMMM D, YYYY"),
          Image: (
            <Badge>
              <Avatar
                src={row.image ? IMAGE_BASE_URL + row.image.filePath : ""}
                shape="circle"
                size="large"
              />
            </Badge>
          ),
          Action: (
            <Space>
              <Button onClick={() => navigate("/blog/edit/" + row.id)} block>
                Edit
              </Button>
              <Popconfirm
                title="Delete the blog"
                description="Are you sure to delete this blog?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(formattedData);
        setFilteredState(formattedData);
      } else {
        setState([]);
        setFilteredState([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredState([]);
      setLoading(false);
    };
    getAPI(ALL_BLOG, successFn, errorFn, {});
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter((data) =>
      data.Name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const deleteData = (id) => {
    setLoading(true);
    const data = { id };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_BLOG, data, successFn, errorFn);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Image",
      dataIndex: "Image",
      width: 50,
    },
    {
      title: "Title",
      dataIndex: "Name",
      width: 150,
    },
    {
      title: "Publish Date",
      dataIndex: "Date",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Manage Blog/News"
          extra={
            <Space>
              <Input
                placeholder="Search by Name"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
              />
              <Button onClick={() => navigate("/blog/add")}>
                Add <PlusOutlined />
              </Button>
            </Space>
          }
          bordered
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 240 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default BlogTable;
